import { useEffect, useState } from 'react';

import useBrowserMode from '@/shared/hooks/useBrowserMode';
import './controlSecurity.scss';

interface ControlInterface {
  setValidation: any;
}

const ControlSecurity = (props: ControlInterface) => {
  const { setValidation } = props;
  const [code, setCode] = useState('');
  const [codeToValidate, setCodeToValidate] = useState('');
  const [num, setNum] = useState('');
  const { window } = useBrowserMode();

  const handleNumChange = (event) => {
    const limit = 6;
    setCodeToValidate(event.target.value.slice(0, limit));
    setNum(event.target.value.slice(0, limit));
  };

  const getRandomNumber = () => {
    const crypto = window?.crypto || window?.msCrypto;
    if (!crypto) return;
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return array[0].toString().slice(0, 6);
  };

  useEffect(() => {
    setCode(getRandomNumber() || '123456');
  }, []);

  useEffect(() => {
    if (codeToValidate !== '' && code !== '' && codeToValidate === code) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  }, [codeToValidate]);

  return (
    <div className="a-controlSecurity">
      <div className="a-controlSecurity__container">
        <div className="a-controlSecurity__container__description">
          <h2>Control de seguridad</h2>
          <p>Escribe el código correctamente en el campo</p>
        </div>
        <div className="a-controlSecurity__container__code">
          <p>{code}</p>
          <input
            type="number"
            placeholder="000000"
            value={num}
            onChange={(e) => {
              handleNumChange(e);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ControlSecurity;
